import type { CreatureSkillIdentityRegistry, HydratedCreatureSkillEntry } from '../types';
import { phpJsonInt as phpInt } from './php-json-values';

/** Rehydrate one lean stored skill entry after the caller resolves the static skill registry. */
export function hydrateCreatureSkillEntry(
    storedEntry: Readonly<Record<string, unknown>>,
    variableName: string,
    registry: CreatureSkillIdentityRegistry,
): HydratedCreatureSkillEntry {
    const entry: Record<string, unknown> = { ...storedEntry };
    const tierLevel = phpInt(entry.tier_level);
    const has = (key: string) => Object.prototype.hasOwnProperty.call(entry, key);
    const isSet = (key: string) => has(key) && entry[key] !== null;
    const add = (key: string, value: unknown) => { if (!has(key)) entry[key] = value; };

    if (!isSet('item_id') || !isSet('item_name') || !isSet('item_type')) {
        const itemId = String(entry.item_id ?? '').toUpperCase();
        const definition = (variableName !== '' && Object.prototype.hasOwnProperty.call(registry.byVariable, variableName)
            ? registry.byVariable[variableName] : undefined)
            ?? (isSet('item_id') && Object.prototype.hasOwnProperty.call(registry.byId, itemId) ? registry.byId[itemId] : undefined);
        if (definition) {
            add('item_id', definition.item_id ?? '');
            add('item_name', definition.item_name ?? '');
            add('item_type', definition.item_type ?? '');
        }
    }

    add('tier', `skill_tier_${tierLevel}`);
    add('is_flawed', tierLevel === 0);
    add('adv_dis_stacks', 0);
    add('raw_sp', null);
    add('roll', { dice: tierLevel > 0 ? 1 : 0, die: tierLevel > 0 ? tierLevel + 3 : 0 });
    add('skill_rolls_mod', 0);
    add('skill_roll_mod', 0);
    add('forced_natural_main_roll', null);
    if (!has('mod') || entry.mod === null) {
        entry.mod = phpInt(entry.skill_rolls_mod) + phpInt(entry.skill_roll_mod);
    }
    return entry as HydratedCreatureSkillEntry;
}
